// layouts/catalogos/formatos/datosformatos.js
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { ui } from "ui/tokens";

export const columns = [
  { name: "nombre", align: "left", sortable: true },
  { name: "creado", align: "center", sortable: true },
  { name: "acciones", align: "center" },
];

const formatDate = (d) => {
  if (!d) return "—";
  try {
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return d;
    return dt.toLocaleDateString(); // o el mismo formato que uses en sellos
  } catch {
    return "—";
  }
};

export default function buildFormatosTable(items = [], map) {
  const rows = (items || []).map((it) => {
    const r = typeof map === "function" ? map(it) : it;

    const nombre = r.nombre ?? r.name ?? "—";
    const createdRaw = r.creado ?? r.created_at ?? r.createdAt ?? null;

    return {
      nombre: (
        <SoftTypography variant="button" fontWeight="medium">
          {nombre}
        </SoftTypography>
      ),
      creado: (
        <SoftTypography variant="caption" color="secondary" fontWeight="medium">
          {formatDate(createdRaw)}
        </SoftTypography>
      ),
      acciones: (
        <SoftBox display="flex" justifyContent="center" gap={0.5}>
          {typeof r.onEdit === "function" && (
            <IconButton
              size="small"
              onClick={r.onEdit}
              title="Editar"
              sx={{
                "& .icon-edit": { color: ui.icon?.edit?.base || "#0ea5e9" },
                "&:hover .icon-edit": { color: ui.icon?.edit?.hover || "#0284c7" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-edit" fontSize="small">
                edit
              </Icon>
            </IconButton>
          )}
          {typeof r.onDelete === "function" && (
            <IconButton
              size="small"
              onClick={r.onDelete}
              title="Eliminar"
              sx={{
                "& .icon-del": { color: ui.icon?.del?.base || "#ef4444" },
                "&:hover .icon-del": { color: ui.icon?.del?.hover || "#b91c1c" },
                transition: "transform .15s ease",
                "&:hover": { transform: "scale(1.12)" },
              }}
            >
              <Icon className="icon-del" fontSize="small">
                delete
              </Icon>
            </IconButton>
          )}
        </SoftBox>
      ),
    };
  });

  return { columns, rows };
}
